import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { $mapLoaded } from '../../models/mapModel/index.js';
import {
  $activeMetric,
  $mudfloodsArea,
} from '../../models/logicModel/index.js';
import { changeLayerVisibility } from '../../utils/mapbox-utils.js';

const gradientProp = [
  'case',
  ['all', ['==', ['get', 'index'], 1]],
  '#BBDEFB',
  ['all', ['==', ['get', 'index'], 2]],
  '#2196F3',
  ['all', ['==', ['get', 'index'], 3]],
  '#0D47A1',
  'rgba(0,0,0,0.7)',
];

function MudfloodsLayer() {
  const mapLoaded = useUnit($mapLoaded);
  const polygons = useUnit($mudfloodsArea);
  const acitveMetric = useUnit($activeMetric);

  const createLayer = (update) => {
    const mudfloodData = {
      type: 'FeatureCollection',
      features: polygons,
    };

    if (update) {
      window.map.getSource('un_mudfloods_source').setData(mudfloodData);
    } else {
      if (!window.map.getSource('un_mudfloods_source')) {
        window.map.addSource('un_mudfloods_source', {
          type: 'geojson',
          data: mudfloodData,
        });
      }

      if (!window.map.getLayer('un_mudfloods_layer')) {
        window.map.addLayer({
          id: 'un_mudfloods_layer',
          type: 'fill',
          source: 'un_mudfloods_source',
          paint: {
            'fill-color': gradientProp,
            'fill-opacity': 0.5,
          },
        });

        window.map.addLayer({
          id: 'un_mudfloods_outline',
          type: 'line',
          source: 'un_mudfloods_source',
          paint: {
            'line-color': gradientProp,
            'line-width': 1,
          },
        });
      }

      changeLayerVisibility('un_mudfloods_layer', false);
      changeLayerVisibility('un_mudfloods_outline', false);
    }
  };

  useEffect(() => {
    if (mapLoaded && polygons.length > 0) {
      if (window.map.getLayer('un_mudfloods_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, polygons]);

  useEffect(() => {
    if (mapLoaded) {
      if (window.map.getLayer('un_mudfloods_layer')) {
        if (acitveMetric === 'mudflow_ind') {
          changeLayerVisibility('un_mudfloods_layer', true);
          changeLayerVisibility('un_mudfloods_outline', true);
        } else {
          changeLayerVisibility('un_mudfloods_layer', false);
          changeLayerVisibility('un_mudfloods_outline', false);
        }
      }
    }
  }, [mapLoaded, acitveMetric]);

  return null;
}

export default MudfloodsLayer;
